export default __webpack_public_path__ + "static/media/home_step_one.da6a1c73.png";